import { Controller } from '@hotwired/stimulus';
import appNoty from '../../libs/appNoty';

export default class extends Controller {
  static values = { key: String, message: String, instant: Boolean };

  connect() {
    if (this.instantValue) {
      this.send();
      return;
    }
    window.addEventListener('noticeEvent', (evt) => {
      this.sendNoticeEvent(evt);
    });
    const noticeEventJson = window.sessionStorage.getItem('noticeEvent');
    if (noticeEventJson) {
      const noticeEvent = JSON.parse(noticeEventJson);
      this.sendNoticeEvent(noticeEvent);
      window.sessionStorage.removeItem('noticeEvent');
    }
  }

  sendNoticeEvent(noticeEvent) {
    this.keyValue = noticeEvent.detail.type;
    this.messageValue = noticeEvent.detail.message;
    this.send();
  }

  disconnect() {
    this.noti.barDom.remove();
    this.element.remove();
  }

  send() {
    if (this.keyValue === 'alertModal') {
      alert(this.messageValue);;
      return;
    }
    this.noti = appNoty(this.messageValue, this.keyValue).show();
  }
}

export function buildNotice(message) {
  return {
    detail: {
      type: 'notice',
      message,
    },
  };
}

export function buildAlert(message) {
  return {
    detail: {
      type: 'alert',
      message,
    },
  };
}

export function reloadAndSendAlert(message) {
  const alert = buildAlert(message);
  window.sessionStorage.setItem('noticeEvent', JSON.stringify(alert));
  location.reload();
}

export function reloadAndSendNotice(message) {
  const notice = buildNotice(message);
  window.sessionStorage.setItem('noticeEvent', JSON.stringify(notice));
  location.reload();
}

export function sendNotice(message) {
  const noticeEvent = new CustomEvent('noticeEvent', buildNotice(message));
  window.dispatchEvent(noticeEvent);
}

export function sendAlert(message) {
  const noticeEvent = new CustomEvent('noticeEvent', buildAlert(message));
  window.dispatchEvent(noticeEvent);
}

export function callBackAndSendNotice(callback, message) {
  const notice = buildNotice(message);
  window.sessionStorage.setItem('noticeEvent', JSON.stringify(notice));
  callback();
}

export function callBackAndSendAlert(callback, message) {
  const alert = buildAlert(message);
  window.sessionStorage.setItem('noticeEvent', JSON.stringify(alert));
  callback();
}
